import { FC, ReactElement, memo } from 'react';
import { IOrderProductExclusion } from 'src/types/orders';
import { getTranslate } from 'src/utils/helpers';
import './style.scss';

interface IProps {
  exclusion: IOrderProductExclusion;
}

export const OrderProductExclusion: FC<IProps> = memo((props: IProps): ReactElement => {
  return <p className="order-product-exclusion">{getTranslate(props.exclusion.name)}</p>;
});
